<div
    class="popup"
    [style.left.px]="x"
    [style.top.px]="y"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
    (dblclick)="$event.stopPropagation()">
    <div
        class="option"
        *ngFor="let icon of icons"
        [title]="icon.title || icon.value"
        (click)="select(icon.value, $event)">
        <mat-icon [svgIcon]="icon.svgIcon" class="icon" [ngClass]="getIconStyleVariant()"> </mat-icon>
    </div>
</div>
